// #636: pdf.js erst laden, wenn ein PDF geöffnet wird (eigener Chunk, der
// Hauptbundle bleibt so groß wie bisher). Der Worker liegt als eigene Datei
// unter /pdfjs/ (scripts/pdfWorkerKopieren.js), passend zu worker-src 'self'.
// isEvalSupported: false schließt CVE-2024-4367 zusätzlich aus und braucht
// kein 'unsafe-eval' in der CSP.
let pdfjsLaden = null;

export function ladePdfjs() {
  if (!pdfjsLaden) {
    pdfjsLaden = import('pdfjs-dist/legacy/build/pdf.mjs').then((pdfjs) => {
      pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdfjs/pdf.worker.min.js?v=${pdfjs.version}`;
      return pdfjs;
    }).catch((err) => {
      pdfjsLaden = null;
      throw err;
    });
  }
  return pdfjsLaden;
}

export async function oeffnePdf(blob) {
  const pdfjs = await ladePdfjs();
  const data = new Uint8Array(await blob.arrayBuffer());
  return pdfjs.getDocument({ data, isEvalSupported: false }).promise;
}
